module.exports = __webpack_public_path__ + "media/theme/sample__mobage--sp-2cdafe53.png";